export const state = {
  buissness: [],
  networks: [],
  profile: [],
  messages:[],
  updateAlbum: false,
}